import { Component, OnInit } from '@angular/core';
import { AwardsService } from '../awards.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DisplayService } from '../../../shared/display.service';
import { CountryService } from '../../../shared/country.service';
import { CurrencyService } from '../../../shared/currency.service';
import { AnalyticsService } from 'src/app/shared/analytics/analytics.service';
import { SERVER_API_URL } from 'src/app/app.constants';
import { UrlService } from '../../../shared/url.service';

@Component({
  selector: 'app-awards-country',
  templateUrl: './awards-country.component.html',
  styleUrls: ['./awards-country.component.scss']
})
export class AwardsCountryComponent implements OnInit {
  FLAG_URL = SERVER_API_URL + 'countries/flag/';

  awardsCountryData: any;
  countryData: any;
  activeAccordion: string[] = ['CountryFacts', 'SpectrumAuthority', 'CountryOutlook'];
  dtOptions: DataTables.Settings = {};

  constructor(
    private awardsService: AwardsService,
    private route: ActivatedRoute,
    public displayService: DisplayService,
    public countryService: CountryService,
    private router: Router,
    public analyticsService: AnalyticsService,
    public currencyService: CurrencyService,
    public urlService: UrlService
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }

  ngOnInit() {
    this.dtOptions = {
      "order": [[0, "desc"]],
      "lengthChange": false,
      "searching": false,
      "paging": false,
      "info": false,
      "columnDefs": [
        { "orderable": false, "targets": 1 },
        { "orderable": false, "targets": 7 },
      ]
    };
    this.route.params.subscribe(p => {
      this.awardsService.getAwardsByCountry(p.countryCode)
        .subscribe(data => {
          this.awardsCountryData = data;
        });
      this.countryService.getCountryExternalInformations(p.countryCode)
        .subscribe(data => {
          this.countryData = data;
        });
    });
  }

  getDocumentUrl(uniqueNumber: string): string {
    return this.urlService.getClientSiteUrl(uniqueNumber);
  }

  onClickAccordion(name: string) {
    const index = this.activeAccordion.indexOf(name);
    if (index > -1) {
      // Si l'accordéon est déjà ouvert, le fermer
      this.activeAccordion.splice(index, 1);
    } else {
      // Sinon, l'ouvrir
      this.activeAccordion.push(name);
    }
  }

  isActiveAccordion(name: string): boolean {
    return this.activeAccordion.includes(name);
  }

  hideSpectrumAuthority(country: any): boolean {
    return !country.authority && !country.legalBasis && !country.allocationTable;
  }

  hideStatus(row: any): boolean {
    return !row.status && !row.statusComment;
  }

  hideAccordionArrow(country: any): boolean {
    return !country.authority && !country.legalBasis && !country.allocationTable && !country.countryOutlook;
  }

  getImageUrl(url: string) {
    return this.FLAG_URL + url;
  }

  isSpectrumLightContent(value: string) {
    if (value === 'BLUR_CONTENT') {
      return '<p class="SpectrumLight">Upgrade...</p>';
    } else {
      return value;
    }
  }

  isSpectrumLightComment(value: string) {
    if (value === 'BLUR_COMMENT') {
      return '';
    } else {
      return value;
    }
  }

  changePopulationFormat(number: number): string {
    const decimalFormatBn = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const decimalFormatM = new Intl.NumberFormat('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    const decimalFormatM2 = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (number >= 1_000_000_000) {
      const result = number / 1_000_000_000;
      return decimalFormatBn.format(result) + 'bn';
    } else if (number >= 1_000_000) {
      const result = number / 1_000_000;
      return decimalFormatM.format(result) + 'm';
    } else if (number >= 100_000) {
      const result = number / 1_000_000;
      return decimalFormatM2.format(result) + 'm';
    } else {
      return String(number);
    }
  }
}